import { FontelloIconType } from '../../themes/FontelloIconType'

export const FontelloIconMap: Record<FontelloIconType, true> = {
    search: true,
    account_circle: true,
    add: true,
    calendar_add_on: true,
    notifications_filled: true,
    notifications: true,
    skiing: true,
    south: true,
    west: true,
    east: true,
    north: true,
    article_filled: true,
    article: true,
    contrast: true,
    assist: true,
    athletics: true,
    autoplay: true,
    autoplay_off: true,
    baseball: true,
    basketball: true,
    boxing: true,
    menue: true,
    calendar_month_filled: true,
    calendar_month: true,
    work: true,
    casino: true,
    check_circle: true,
    cast: true,
    close: true,
    apartment: true,
    computer: true,
    directions_bike: true,
    darts: true,
    arrow_drop_down: true,
    arrow_drop_up: true,
    headphones: true,
    edit: true,
    fast_forward: true,
    star_filled: true,
    star: true,
    feedback: true,
    photo_library: true,
    horseriding: true,
    imprint: true,
    public: true,
    heart_filled: true,
    heart: true,
    live_tv_filled: true,
    live_tv: true,
    more_horiz: true,
    motorsports: true,
    skip_next: true,
    pause: true,
    skip_previous: true,
    rugby: true,
    arrow_back_ios_new: true,
    arrow_forward_ios: true,
    expand_less: true,
    settings_filled: true,
    watch: true,
    soccer_filled: true,
    soccer: true,
    sync: true,
    'sync-out': true,
    'sync-in': true,
    swimming: true,
    table_tennis: true,
    shoppingmode: true,
    tennis: true,
    timbersports: true,
    sync_alt: true,
    remote_gen: true,
    mma: true,
    us_sport: true,
    video_library: true,
    volume_off: true,
    volume_up: true,
    wintersports: true,
    battery_full_alt: true,
    battery_horiz_050: true,
    battery_low: true,
    battery_horiz_075: true,
    battery_horiz_000: true,
    cancel: true,
    check_indeterminate_small: true,
    compare_arrows: true,
    desktop_mac: true,
    desktop_windows: true,
    filter_list: true,
    flag_circle: true,
    format_list_numbered: true,
    laptop_mac: true,
    local_hospital: true,
    mark_email_unread: true,
    mobile_friendly: true,
    more_vert: true,
    repeat: true,
    sell: true,
    signal_cellular_alt: true,
    statistic: true,
    stop: true,
    swap_horiz: true,
    tablet_mac: true,
    tune: true,
    verified_user: true,
    wifi_1_bar: true,
    wifi_2_bar: true,
    dark_mode: true,
    ios_share: true,
    share: true,
    goal3: true,
    goal6: true,
    goal4: true,
    goal9: true,
    goal8: true,
    goal5: true,
    surfing: true,
    attention: true,
    average: true,
    advertise: true,
    badminton: true,
    better_collective: true,
    biathlon: true,
    bobsledding: true,
    bookmark: true,
    canoe: true,
    checkbox_checked: true,
    checkbox_unchecked: true,
    chess: true,
    comment: true,
    email: true,
    error: true,
    fencing: true,
    fitness: true,
    flag: true,
    finish_flag: true,
    fullscreen: true,
    lineup: true,
    esports: true,
    golf: true,
    fullscreen_exit: true,
    gymnastics: true,
    handball: true,
    hockey: true,
    home_filled: true,
    home: true,
    icehockey: true,
    live: true,
    live_filled: true,
    luge: true,
    maps: true,
    martial_arts: true,
    media: true,
    media_filled: true,
    news: true,
    newsletter: true,
    nordic_combination: true,
    own_goal: true,
    partner: true,
    smart_display: true,
    play_arrow: true,
    podcast: true,
    poker: true,
    quote: true,
    replay: true,
    fast_rewind: true,
    sailing: true,
    sale: true,
    scoreboard: true,
    scoreboard_filled: true,
    settings: true,
    shopping_bag: true,
    smartphone: true,
    sports: true,
    sync_out: true,
    sync_in: true,
    expand_more: true,
    triathlon: true,
    trophy: true,
    tv: true,
    'check_indeterminate_small-1': true,
    var: true,
    boulevard: true,
    visibility: true,
    volleyball: true,
    whistle: true,
    wifi: true,
    wifi_off: true,
    perm_scan_wifi: true,
    wrestling: true,
    dot: true,
    shield: true,
    shield_person: true,
    signal_cellular_alt_1_bar: true,
    signal_cellular_alt_2_bar: true,
    toggle_off: true,
    toggle_on: true,
    new: true,
    goal2: true,
    goal7: true,
    american_football: true,
    data_table: true,
    'card-yellow-red': true,
    'card-yellow-red-bottom': true,
    'card-red': true,
    'card-yellow': true,
    ski_alpine: true,
    'ice-skating': true,
    cross_country_ski: true,
    facebook: true,
    'x-(twitter)': true,
    instagram: true,
    beachvolleyball: true,
    expert: true,
    time: true,
    info: true,
    check: true,
    up: true,
    ski_jumping: true,
} as const

export function isFontelloIcon(name: unknown): name is FontelloIconType {
    return typeof name === 'string' && name in FontelloIconMap
}
